<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header">
      <button *ngIf="showPricingStep" class="btn btn-light" (click)="backToForm()" [disabled]="loading.submit || loading.pricing">
        <i class="fa fa-angle-left"></i>
        Back
      </button>
      <h5 class="mb-0">Request EKS</h5>
    </div>
  </div>

  <div *ngIf="!showPricingStep" class="card-body">
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <label>AWS Account Id</label>
        <input class="form-control" [ngModel]="accountId" disabled />
      </div>
      <div class="col-12 col-md-6">
        <label>Region</label>
        <input class="form-control" [ngModel]="regionId" disabled />
      </div>

    <div class="col-12">
      <label>Launch Justification <span class="required-star">*</span></label>
      <textarea class="form-control" [(ngModel)]="form.launch_justification" [ngModelOptions]="{ standalone: true }" rows="2" placeholder="Enter launch justification"></textarea>
    </div>

    <div class="col-12">
      <label>Cluster Name <span class="required-star">*</span></label>
      <input class="form-control" [(ngModel)]="form.cluster_name" [ngModelOptions]="{ standalone: true }" placeholder="Enter cluster name" />
    </div>

    <div class="col-12">
      <label>
        VPC Id <span class="required-star">*</span>
        <span *ngIf="loading.vpcs" class="tiny-loader"></span>
      </label>
      <ng-select
        class="instance-type-select"
        [items]="options.vpcs"
        bindLabel="vpc_id"
        bindValue="vpc_id"
        [(ngModel)]="form.vpc_id"
        [ngModelOptions]="{ standalone: true }"
        (change)="onVpcChange()"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No VPC found"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.vpc_id }} {{ item.vpc_name ? '- (' + item.vpc_name + ')' : '' }}
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12">
      <label>
        Subnet Ids <span class="required-star">*</span>
        <span *ngIf="loading.subnets" class="tiny-loader"></span>
      </label>
      <ng-select
        class="instance-type-select"
        [items]="options.subnets"
        bindLabel="subnet_id"
        bindValue="subnet_id"
        [(ngModel)]="form.subnet_ids"
        [ngModelOptions]="{ standalone: true }"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [disabled]="!form.vpc_id"
        placeholder="Select"
        notFoundText="No subnet found"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.subnet_id }} {{ item.subnet_name ? '- (' + item.subnet_name + ')' : '' }}
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12">
      <label>
        Security Group Ids <span class="required-star">*</span>
        <span *ngIf="loading.securityGroups" class="tiny-loader"></span>
      </label>
      <ng-select
        class="instance-type-select"
        [items]="options.securityGroups"
        bindLabel="security_group_name"
        bindValue="security_group_id"
        [(ngModel)]="form.security_group_ids"
        [ngModelOptions]="{ standalone: true }"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [disabled]="!form.vpc_id"
        placeholder="Select"
        notFoundText="No security group found"
      >
      </ng-select>
    </div>

    <div class="col-12">
      <label>
        Cluster Role ARN <span class="required-star">*</span>
        <span *ngIf="loading.clusterRoles" class="tiny-loader"></span>
      </label>
      <ng-select
        class="instance-type-select"
        [items]="options.clusterRoles"
        bindLabel="role_arn"
        bindValue="role_arn"
        [(ngModel)]="form.cluster_role_arn"
        [ngModelOptions]="{ standalone: true }"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No cluster role found"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.role_name }} - {{ item.role_arn }}
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12">
      <label>
        Kubernetes Version <span class="required-star">*</span>
        <span *ngIf="loading.kubernetesVersions" class="tiny-loader"></span>
      </label>
      <ng-select
        class="instance-type-select"
        [items]="options.kubernetesVersions"
        bindLabel="cluster_version"
        bindValue="cluster_version"
        [(ngModel)]="form.kubernetes_version"
        [ngModelOptions]="{ standalone: true }"
        [searchable]="true"
        [clearable]="true"
        placeholder="Select"
        notFoundText="No Kubernetes version found"
      >
        <ng-template ng-option-tmp let-item="item">
          {{ item.cluster_version }} {{ item.default_version ? '(default)' : '' }} - {{ item.version_status }}
        </ng-template>
      </ng-select>
    </div>

    <div class="col-12 col-md-6">
        <label>Endpoint Public Access <span class="required-star">*</span></label>
        <ng-select class="instance-type-select" [(ngModel)]="form.endpoint_public_access" [ngModelOptions]="{ standalone: true }" [searchable]="false" [clearable]="false" placeholder="Select">
          <ng-option [value]="true">true</ng-option>
          <ng-option [value]="false">false</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-6">
        <label>Endpoint Private Access <span class="required-star">*</span></label>
        <ng-select class="instance-type-select" [(ngModel)]="form.endpoint_private_access" [ngModelOptions]="{ standalone: true }" [searchable]="false" [clearable]="false" placeholder="Select">
          <ng-option [value]="true">true</ng-option>
          <ng-option [value]="false">false</ng-option>
        </ng-select>
      </div>

    <div class="col-12">
      <label>Tags <span class="required-star">*</span></label>
      <div *ngFor="let t of form.tags; let i = index" class="tag-row">
        <input class="form-control" placeholder="key" [(ngModel)]="t.key" [ngModelOptions]="{ standalone: true }" />
        <input class="form-control" placeholder="value" [(ngModel)]="t.value" [ngModelOptions]="{ standalone: true }" />
        <button type="button" class="btn btn-outline-secondary btn-sm tag-remove" (click)="removeTag(i)">X</button>
      </div>
      <button class="btn btn-light btn-sm" (click)="addTag()"><i class="fa fa-plus"></i> Add Tag</button>
    </div>

    </div>
  </div>

  <div *ngIf="!showPricingStep" class="card-footer step-footer">
    <button class="btn btn-primary" (click)="goToPricing()" [disabled]="!canSubmit() || loading.pricing">
      {{ loading.pricing ? 'Loading...' : 'Next' }}
    </button>
  </div>

  <div *ngIf="showPricingStep" class="card-body form-grid">
    <div class="form-item">
      <label>Pricing</label>
      <div *ngIf="loading.pricing" class="mapping-box">Fetching pricing...</div>
      <div *ngIf="!loading.pricing && pricingError" class="mapping-box text-danger">{{ pricingError }}</div>
      <div *ngIf="!loading.pricing && clusterPricing" class="mapping-box">
        <div class="form-item">
          <label>Hourly Cost</label>
          <input class="form-control" [ngModel]="(clusterPricing.hourly_cost_usd ?? '-') + ' ' + (clusterPricing.currency || 'USD')" disabled />
        </div>
        <div class="form-item">
          <label>Monthly Cost</label>
          <input class="form-control" [ngModel]="(clusterPricing.monthly_cost_usd ?? '-') + ' ' + (clusterPricing.currency || 'USD')" disabled />
        </div>
      </div>

      <div *ngIf="saveSuccessMessage" class="alert alert-success save-success-message mt-2 mb-0">
        <div>{{ saveSuccessMessage }}</div>
      </div>
      <div *ngIf="saveError" class="alert alert-danger save-error-message mt-2 mb-0">
        {{ saveError }}
      </div>

      <div class="step-footer mt-2">
        <button class="btn btn-primary" (click)="submitRequest()" [disabled]="loading.submit || !clusterPricing || !!pricingError">
          {{ loading.submit ? 'Submitting...' : 'Request EKS' }}
        </button>
      </div>
    </div>
  </div>
</div>
